// extracted by mini-css-extract-plugin
export var content = "privacy-module--content--YJCZd";
export var date = "privacy-module--date--CeAYa";
export var sectionTitle = "privacy-module--sectionTitle--0QniO";